import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataviewHeader = _resolveComponent("DataviewHeader")!
  const _component_DataviewFiltersComponent = _resolveComponent("DataviewFiltersComponent")!
  const _component_DataviewTable = _resolveComponent("DataviewTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataviewHeader, {
      dtPost: _ctx.templateData.data_view,
      feTheme: _ctx.feTheme,
      templateData: _ctx.templateData,
      onResetAll: _ctx.filtersSubmit,
      onSearch: _ctx.searchSubmit
    }, null, 8, ["dtPost", "feTheme", "templateData", "onResetAll", "onSearch"]),
    _createVNode(_component_DataviewFiltersComponent, {
      dtPost: _ctx.templateData.data_view,
      tableFiltersEnabled: _ctx.templateData.enable_filters_bar,
      tableFilters: _ctx.templateData.table_filters,
      dateFilters: _ctx.templateData.date_filter,
      search: _ctx.search,
      vw: _ctx.wrapperView,
      feTheme: _ctx.feTheme,
      filtersPosition: _ctx.templateData.filters_position,
      softFilterArgument: _ctx.softFilterArgument,
      onFiltersSubmit: _ctx.filtersSubmit,
      onFiltersReset: _ctx.filtersSubmit
    }, null, 8, ["dtPost", "tableFiltersEnabled", "tableFilters", "dateFilters", "search", "vw", "feTheme", "filtersPosition", "softFilterArgument", "onFiltersSubmit", "onFiltersReset"]),
    _createVNode(_component_DataviewTable, {
      dtPost: _ctx.data.data_view,
      templateData: _ctx.data,
      feTheme: _ctx.feTheme,
      keyword: _ctx.keyword,
      onSort: _ctx.sortAction
    }, null, 8, ["dtPost", "templateData", "feTheme", "keyword", "onSort"])
  ], 64))
}